/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_1_AnswerInputs */

const en_svc_research_faq_1_answer = /** @type {(inputs: Svc_Research_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chat answer is one model’s best guess. A research agent searches, reads the actual sources, checks claims against each other and cites every one, inside a process you can repeat and audit.`)
};

const lv_svc_research_faq_1_answer = /** @type {(inputs: Svc_Research_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarunas atbilde ir viena modeļa labākais minējums. Izpētes aģents meklē, lasa īstos avotus, salīdzina apgalvojumus un norāda katru avotu, procesā, ko var atkārtot un pārbaudīt.`)
};

/**
* | output |
* | --- |
* | "A chat answer is one model’s best guess. A research agent searches, reads the actual sources, checks claims against each other and cites every one, inside a ..." |
*
* @param {Svc_Research_Faq_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_1_answer = /** @type {((inputs?: Svc_Research_Faq_1_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_1_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_1_answer(inputs)
	return en_svc_research_faq_1_answer(inputs)
});